module.exports = __webpack_public_path__ + "static/elephantcomforterrattle-8f628e45c3d6a9c2e3b1b13055500166.jpeg";